import React from 'react';

export enum STEPS {
  search = 1,
  match,
  selectOption,
  buy,
}

export interface StepProps {
  search: JSX.Element;
  match: JSX.Element;
  selectOption: JSX.Element;
  buy?: JSX.Element;
}

interface Props extends StepProps {
  currentStep: keyof StepProps;
}

const Step: React.FC<Props> = ({ currentStep, children, ...steps }) => <>{steps[currentStep]}</>;

export default Step;
